<!-- TODO: evaluate the possibility of breaking this into smaller components -->
@let rowsPerPage =
  store.pluginSg()?.feature?.selectors?.paginationQuantity?.asSignal();
@let paginationIsPageInputDisabled =
  store
    .pluginSg()
    ?.feature?.selectors?.paginationIsPageInputDisabled?.asSignal();
@let selectedPageNumber =
  store
    .pluginSg()
    ?.feature?.selectors?.paginationSelectedPageNumber?.asSignal();

<div class="atn-pagination">
  <div class="atn-pagination__page-size">
    <span class="atn-pagination__text">Rows per page</span>
    <div class="atn-pagination__select">
      <atn-ds-select-single
        [items]="supportedPageSizesSg()"
        [value]="rowsPerPage"
        (valueChange)="quantityChangeHandler($event)"
      />
    </div>
  </div>
  @let hasPreviousPage =
    store.pluginSg()?.feature?.selectors?.paginationHasPreviousPage?.asSignal();
  <div class="atn-pagination__page-navigation">
    <div
      class="atn-pagination__page"
      [ngClass]="{
        'atn-pagination__page--disabled': !hasPreviousPage,
      }"
      (click)="hasPreviousPage && previousArrowClickHandler()"
    >
      <span class="mr-1">&lt;</span> Prev
    </div>
    @for (
      pageToNavigate of store
        .pluginSg()
        ?.feature?.selectors?.paginationPreviousPagesToNavigate?.asSignal();
      track $index
    ) {
      @if (pageToNavigate === undefined) {
        <div class="atn-pagination__page atn-pagination__page--dots">...</div>
      } @else {
        <div
          class="atn-pagination__page"
          (click)="pageChangeHandler('Clicked', pageToNavigate)"
        >
          {{ pageToNavigate }}
        </div>
      }
    }
    <div class="atn-pagination__selected-page">
      <atn-ds-text
        [disabled]="paginationIsPageInputDisabled"
        [value]="selectedPageNumber?.toString()"
        (change)="pageChangeHandler('Changed', $event)"
      />
    </div>
    @for (
      pageToNavigate of store
        .pluginSg()
        ?.feature?.selectors?.paginationNextPagesToNavigate?.asSignal();
      track $index
    ) {
      @if (pageToNavigate === undefined) {
        <div class="atn-pagination__page atn-pagination__page--dots">...</div>
      } @else {
        <div
          class="atn-pagination__page"
          (click)="pageChangeHandler('Clicked', pageToNavigate)"
        >
          {{ pageToNavigate }}
        </div>
      }
    }
    @let hasNextPage =
      store.pluginSg()?.feature?.selectors?.paginationHasNextPage?.asSignal();
    <div
      class="atn-pagination__page"
      [ngClass]="{
        'atn-pagination__page--disabled': !hasNextPage,
      }"
      (click)="hasNextPage && nextArrowClickHandler()"
    >
      Next <span class="ml-1">&gt;</span>
    </div>
  </div>
  <div class="atn-pagination__count">
    <span
      class="atn-pagination__text"
      data-test-id="number-of-item-per-page"
    >
      {{
        store
          .pluginSg()
          ?.feature?.selectors?.paginationDisplayedRange?.asSignal()
      }}
    </span>
  </div>
</div>
